module.exports = __webpack_public_path__ + "static/media/Reservation-07.faa87d6f.svg";